import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const isWhitespace = control.value.length ? control.value.trim().length === 0 : false;
        return isWhitespace ? { whitespace: true } : null;
    };
}